import { Link } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";

const Columns: GridColDef[] = [
  {
    field: "actions",
    headerName: "Editar",
    type: "actions",
    width: 60,
    renderCell: (params: any) => (
      <Link to={`/survey/user-edit/${params?.row?.identificationNumber}`}>
        <IconButton aria-label='edit' size='small'>
          <EditIcon fontSize='inherit' />
        </IconButton>
      </Link>
    ),
  },
  { field: "nameUN", headerName: "Empresa", width: 250, headerAlign: "center" },
  { field: "nameUP", headerName: "Finca", width: 250, headerAlign: "center" },
  { field: "identificationNumber", headerName: "No Identificación", width: 130, headerAlign: "center" },
  { field: "fullName", headerName: "Nombre", width: 250, headerAlign: "center" },
  { field: "eMail", headerName: "Correo", width: 300, headerAlign: "center" },
  { field: "phone", headerName: "Teléfono", width: 120, headerAlign: "center" },
  { field: "surveyLastUpdate", headerName: "Ult. Act. Encuesta", width: 130, align: "center", headerAlign: "center" },
  { field: "noSurvey", headerName: "#Encuestas", type: "number", width: 100, align: "center", headerAlign: "center" },
  { field: "completedSurvey", headerName: "Encuesta Completada", width: 160, align: "center", headerAlign: "center" },
  { field: "surveyStatus", headerName: "Estado encuesta", width: 130, align: "center", headerAlign: "center" },
  { field: "position", headerName: "Pág. Completada", width: 130, align: "center", headerAlign: "center" },
  {
    field: "percentage",
    headerName: "%Completado",
    type: "number",
    width: 110,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "sentByEMail",
    headerName: "Enviada por correo",
    type: "dateTime",
    width: 170,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "sentBySMS",
    headerName: "Enviada por sms",
    type: "dateTime",
    width: 170,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "expiredToken",
    headerName: "Expiró el Token",
    type: "string",
    width: 170,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "temporaryCompany",
    headerName: "Empresa Temporal",
    type: "string",
    width: 350,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "idLugarTrabajo",
    headerName: "ID Lugar de Trabajo",
    type: "string",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "lugarTrabajo",
    headerName: "Lugar de Trabajo",
    type: "string",
    width: 250,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "idCentroCosto",
    headerName: "ID Centro de Costos",
    type: "string",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "centroCosto",
    headerName: "Centro de Costos",
    type: "string",
    width: 250,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "updatedBy",
    headerName: "Actualizado por:",
    type: "string",
    width: 200,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "updatedDate",
    headerName: "Ult. Actualización",
    type: "string",
    width: 130,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "excelFileName",
    headerName: "Archivo Excel",
    type: "string",
    width: 250,
    align: "center",
    headerAlign: "center",
  },
];

export default Columns;
